import { HeaderLayoutLeftButton } from "@components/page-layout/header/header-layout-left-button";
import { useCloseAccountSettings } from "@pages/account-settings/use-close-account-settings";
import { CloseIcon } from "@flat-ui";

/** Button in the header to close the account settings page */
export function CloseAccountSettingsButton(): JSX.Element {
  const { onCloseButtonClick } = useCloseAccountSettings();

  return (
    <HeaderLayoutLeftButton
      tooltip="Close Account Settings"
      icon={CloseIcon}
      text="Close"
      onClickHandler={onCloseButtonClick}
    />
  );
}
